export default "__VITE_ASSET__D29I46Zq__"